module.exports = __webpack_public_path__ + "media/images/dashboard-loading-9cfe6577f3b0f621b7c11323fbe3606e.svg";